import styled from 'styled-components';
import { Form as FormBase } from '@unform/web';
import { Table as GlobalTable } from 'styles/global';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;
  margin: 0;

  > div {
    > button {
      align-self: flex-end;
      margin-top: 10px;
      padding: 0 15px 0 15px;
      width: 150px;
    }
  }
  .ButtonGroup {
    margin: 15px 15px 0 15px;
    display: flex;
    justify-content: space-between;
  }
  header {
    align-items: baseline;
    > button {
      margin-right: 10px;
    }
  }
`;

export const Content = styled.div`
  header {
    display: flex;
    align-items: center;
    padding: 0 0 10px 0;
  }
  padding: 0 15px 0 15px;
`;

export const Form = styled(FormBase)`
  display: flex;
  height: 100%;
  flex-direction: column;
  section {
    padding: 0 0 5px 0 !important;
    margin: 0px 0 15px 0;
    border-bottom: 0.5px solid ${props => props.theme.fontColor};
    &:first-of-type {
      margin: 0px 0 15px 0;
    }
  }
`;

export const FormGroup = styled.div`
  display: grid;
  grid-template-columns: 10fr 1fr 4fr 4fr;
  gap: 10px;
  > div {
    &:nth-of-type(2) {
      max-width: 150px;
    }
  }
`;

export const WidgetContent = styled.div`
  flex-grow: auto;
  display: flex;
  margin-bottom: 10px;
`;

export const Table = styled(GlobalTable)`
  th {
    &:not(:first-of-type) {
      text-align: center;
      width: 9rem;
    }
    &:last-of-type {
      width: 1rem;
    }
  }
  td {
    &:not(:first-of-type) {
      text-align: center;
    }
  }
`;

export const RoteiroLocucao = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  > div {
    &:first-of-type {
      margin-right: 1rem;
    }
  }
  h2 {
    margin: 1rem auto;
  }
`;

export const Footer = styled.div`
  display: flex;
  margin-top: 15px;
  justify-content: space-between;
  padding: 0 10px;
  div {
    display: flex;
    gap: 10px;
  }
`;
